import React from 'react';
import DataGrid from '../DataGrid';
import getRoutesGridConfig from './GridConfig';

const GRID_HEADER_CONFIG = {
  showFullscreen: true,
  showShowHideColumns: true,
  showExportCsv: true,
  showSearchBox: true
};

interface RoutesGridProps {
  data: any[];
  onRowsSelected: (rows: any[]) => void;
  onToggleGridMaximize: (isMaximized: boolean) => void;
  isVisible: boolean;
  isMaximized: boolean;
  gridStatus: string | null;
}

const RoutesGrid: React.FC<RoutesGridProps> = ({
  data,
  onRowsSelected,
  onToggleGridMaximize,
  isVisible,
  isMaximized,
  gridStatus
}) => (
  <DataGrid
    title="Routes"
    exportFileName="shipment_movement_routes"
    data={data}
    gridConfig={getRoutesGridConfig}
    onRowsSelected={onRowsSelected}
    onToggleGridMaximize={onToggleGridMaximize}
    isVisible={isVisible}
    isMaximized={isMaximized}
    gridStatus={gridStatus}
    statusLabel="Routes"
    gridHeaderConfig={GRID_HEADER_CONFIG}
  />
);

export default RoutesGrid;
